import React, {useCallback, useContext, useEffect, useState} from "react";
import {useParams, useLocation} from "react-router-dom";
import {loadDataWithCache, sortByOrderMetaData} from '../../utils';
import GridGallery from "../../components/GridGallery/GridGallery";
import {ProjectsContext} from "../../App";
import Laurels from "../../components/Laurels/Laurels";
import ExploreMore from "../../components/ExploreMore/ExploreMore";
import './style.scss';

function Movie () {
    const {imagesCache, setImagesCache} = useContext(ProjectsContext);
    const {state: {description, title, subName, vimeo, src, laurels}} = useLocation();
    const { movieName } = useParams();
    const section = window.location.pathname.startsWith('/directing/') ? 'directing' : 'cinematography';
    const [ gallery, setGallery] = useState([]);
    const [ behindTheScenes, setBehindTheScenes] = useState([]);

    const getData = useCallback(async () => {
        setGallery([]);
        setBehindTheScenes([]);

        const res = await loadDataWithCache(movieName, imagesCache, setImagesCache);
        res.sort((a,b) => sortByOrderMetaData(a,b))

        let {behind, gallery} = Object.groupBy(res, img => {
            if (img.public_id === src)
                return;
            return img.asset_folder.includes('behind') ? "behind" : "gallery"
        });

        setGallery(gallery || []);
        setBehindTheScenes(behind || []);
    }, [movieName, src, imagesCache, setImagesCache]);

    useEffect(() => {
        getData();
    },[getData])

    return (
        <div className='project-page'>
            {title && <div className='description'>
                <div className='title-section'>
                    <h1>{title}</h1>
                    <p className='subName'>{subName}</p>
                </div>
                {description && <p dangerouslySetInnerHTML={{__html: description}}></p>}
                {laurels && <Laurels laurels={laurels} />}
            </div>}
            {vimeo && <div className='video-section' dangerouslySetInnerHTML={{__html: vimeo}}></div>}
            {gallery.length > 0 && <GridGallery images={gallery} lightbox />}
            {behindTheScenes.length > 0 && <GridGallery images={behindTheScenes} lightbox title="BEHIND THE SCENES" className="behind-the-scenes"
            />}
            <ExploreMore currentProject={movieName} section={section}/>
        </div>
    );
}

export default Movie;